import React, { useEffect, useState } from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import { Cookies } from "react-cookie";

const cookies = new Cookies();
const HIDE_COOKIE_KEY = "hide_p04591_arrival_notice";
const PRODUCT_IMAGE_URL =
  "https://megamall-product-image.s3.ap-northeast-2.amazonaws.com/public/products/p04591/1.jpg?t=1790826541220";

function ProductArrivalNoticeModal({ active, onDone }) {
  const [isOpen, setIsOpen] = useState(false);
  const [eligible, setEligible] = useState(null);

  useEffect(() => {
    const isEligible = !cookies.get(HIDE_COOKIE_KEY);
    setEligible(isEligible);
    if (!isEligible) onDone();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (eligible && active) setIsOpen(true);
  }, [eligible, active]);

  const finish = () => {
    setIsOpen(false);
    onDone();
  };

  const handleHidePermanently = () => {
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 10);
    cookies.set(HIDE_COOKIE_KEY, "true", { path: "/", expires });
    finish();
  };

  return (
    <Modal isOpen={isOpen} toggle={finish} centered size="md">
      <ModalBody className="p-4">
        <h5 className="fw-bold text-center mb-3">제품 입고 안내</h5>
        <p>
          안녕하세요.
          <br />
          아래 제품이 입고되어 안내드립니다.
        </p>
        <ul className="mb-3">
          <li>
            <b>제품코드</b>: P04591
          </li>
          <li>
            <b>제품명</b>: PETER&amp;JOHN COLOSTRUM MBP 120TABS
          </li>
        </ul>
        <div className="text-center mb-2">
          <img
            src={PRODUCT_IMAGE_URL}
            alt="PETER&JOHN COLOSTRUM MBP 120TABS"
            style={{ maxWidth: "100%", maxHeight: "260px" }}
          />
        </div>
      </ModalBody>
      <div className="d-flex border-top">
        <Button
          color="light"
          className="w-50 rounded-0"
          onClick={handleHidePermanently}
        >
          다시 보지 않기
        </Button>
        <Button color="dark" className="w-50 rounded-0" onClick={finish}>
          닫기
        </Button>
      </div>
    </Modal>
  );
}

export default ProductArrivalNoticeModal;
